import { render, staticRenderFns } from "./ManagerCandidateItem.vue?vue&type=template&id=6548d557&scoped=true"
import script from "./ManagerCandidateItem.vue?vue&type=script&lang=js"
export * from "./ManagerCandidateItem.vue?vue&type=script&lang=js"
import style0 from "./ManagerCandidateItem.vue?vue&type=style&index=0&id=6548d557&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6548d557",
  null
  
)

export default component.exports